/**
 * These are compile-time constants: there is no remote-config mechanism in
 * this repo, so changing any of them — including switching the endpoints off —
 * needs a web deploy and an app release.
 */
export const UNIT_ENGAGEMENT_CONFIG = {
    enabled: true,
    idleMs: 5 * 60 * 1000,
    heartbeatMs: 2 * 60 * 1000,
    backgroundGraceMs: 30 * 1000,
    maxVisitMs: 30 * 60 * 1000,
    imageBrowseIdleMs: 5 * 1000,
};
